import { orgStorage } from "@/utils/org-storage";
import storeUtils from "@/stores/utils";
import { migrateCatalogEntryFormatFilter } from "@/utils/apiFilterParams";

const DEFAULT_EXCLUDE_KEYS = ["limit", "offset", "ordering"];

/**
 * Build the filter payload persisted in a saved table view.
 */
export function sanitizeFiltersForView(filters, excludeKeys = []) {
    if (!filters || typeof filters !== "object") {
        return {};
    }
    const exclude = new Set([...DEFAULT_EXCLUDE_KEYS, ...excludeKeys]);
    const sanitized = {};
    Object.keys(filters).forEach((key) => {
        if (exclude.has(key)) {
            return;
        }
        const value = filters[key];
        if (value === null || value === undefined || value === "") {
            return;
        }
        if (Array.isArray(value) && value.length === 0) {
            return;
        }
        sanitized[key] = value;
    });
    return migrateCatalogEntryFormatFilter(sanitized);
}

/**
 * Label for a saved view chip.
 */
export function formatViewLabel(view, index) {
    const name = (view?.name || "").trim();
    if (name) {
        return name;
    }
    return `#${view.id || index + 1}`;
}

/**
 * DRF field errors from $storeutils.handleError().details.
 */
export function extractApiFieldErrors(details, field) {
    if (!details || typeof details !== "object" || Array.isArray(details)) {
        return null;
    }
    const value = details[field];
    if (value === null || value === undefined || value === "") {
        return null;
    }
    return Array.isArray(value) ? value : [String(value)];
}

export function activeViewStorageKey(scope) {
    return storeUtils.getActiveViewStorageKey(scope);
}

export function loadActiveViewId(scope) {
    const storageKey = activeViewStorageKey(scope);
    if (!storageKey || typeof window === "undefined") {
        return null;
    }
    try {
        const raw = orgStorage.getItem(storageKey);
        if (!raw) {
            return null;
        }
        const parsed = JSON.parse(raw);
        if (parsed?.id === null || parsed?.id === undefined) {
            return null;
        }
        return parsed.id;
    } catch {
        return null;
    }
}

export function saveActiveViewId(scope, viewId) {
    const storageKey = activeViewStorageKey(scope);
    if (!storageKey || typeof window === "undefined") {
        return;
    }
    try {
        if (viewId === null || viewId === undefined) {
            orgStorage.removeItem(storageKey);
            return;
        }
        orgStorage.setItem(storageKey, JSON.stringify({ id: viewId }));
    } catch {
        // ignore quota errors
    }
}
